export const farmSummaries = {
  _root: "/farm-summary"
};
